import { BaseModel } from './BaseModel';
import LearningUnit from './LearningUnit';

export class LearningUnitSubmissionStat extends BaseModel {
  static get entity() {
    return 'learning-unit-submission-stat';
  }

  static get fk() {
    return 'learning_unit_submission_stat_id';
  }

  static fields() {
    return {
      id: this.attr(null),
      learning_unit_id: this.attr(null),
      learning_unit: this.belongsTo(LearningUnit, 'learning_unit_id'),
      total_submissions: this.number(0),
      total_not_submitted: this.number(0),
      total_in_progress_by_assessor: this.number(0),
      total_in_progress_by_issuer: this.number(0),
      total_denied: this.number(0),
      total_awarded: this.number(0)
    };
  }

  static apiConfig = {
    actions: {
      fetch(params = {}) {
        return this.get('/learning-unit-submission-stat', { params });
      }
    }
  };
}

export default LearningUnitSubmissionStat;
